const doc = [({"da":({"js":({"reimbursements":({"create_card":({"extended_form":({"save_and_request_approval_button":({"save_and_request_approval":"Indsend"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;